import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css"; // Import the CSS
import { useNavigate } from "react-router-dom";
import { Storecontext } from "../../Context/Storecontext";
import LoginPopup from "../LoginPopup/LoginPopup";
import moment from "moment";
const BlogCategoryShow = () => {
  const { url, showLogin } = useContext(Storecontext);

  const token = localStorage.getItem("token");
  const [blogs, setBlogs] = useState([]);
  const [currentPage, setCurrentPage] = useState(1); // Start with page 1
  const [totalPages, setTotalPages] = useState(1); // Total pages
  // const [loading, setLoading] = useState(false); // Loading state
  const [error, setError] = useState(null);
  const navigate = useNavigate(); // Hook to programmatically navigate
  const itemsPerpage = 10;
  // Function to fetch blogs with pagination
  const fetchBlogs = async (page = 1) => {
    // setLoading(true);
    try {
      const response = await axios.get(`${url}/api/category/list`, {
        params: {
          page: page, // Pass the page number
          limit: itemsPerpage,
        },
        headers: { token },
      });
      if (response.data.success) {
        setBlogs(response.data.categories);
        setCurrentPage(response.data.currentPage);
        setTotalPages(response.data.totalPages);
      } else {
        toast.error(response.data.message);
      }
    } catch (err) {
      setError("Failed to load blogs");
      console.error(err);
    }
    //  finally {
    //   setLoading(false);
    // }
  };

  // Fetch blogs when the component mounts or the page changes
  useEffect(() => {
    fetchBlogs(currentPage);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage, token]);

  // Function to handle page change
  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };
  const handleRedirectEdit = (id) => {
    // Navigate to a route with the item's ID
    navigate(`/category-management/categoryedit/${id}`);
  };
 
  const removeCategory = async (id) => {
    const response = await axios.delete(`${url}/api/category/remove/${id}`, {
      headers: { token },
    });
    if (response.data.success) {
      toast.success(response.data.message);
    } else {
      toast.error(response.data.message);
    }
    await fetchBlogs();
  };
  const handleDeleteConfirmation = (id) => {
    const isConfirmed = window.confirm(
      "Are you sure you want to delete this blog?"
    );

    if (isConfirmed) {
      removeCategory(id); // Call the delete function if confirmed
    }
  };

  return (
    <div className="container d-flex p-2 mt-4 justify-content-center align-items-center">
      {showLogin ? (
        <LoginPopup />
      ) : (
        <>
          {error ? (
            <div className="alert alert-danger text-center">{error}</div>
          ) : (
            <div className="container py-4">
              <ToastContainer/>
              {/* Header */}
              <div className="d-flex flex-wrap justify-content-between align-items-center mb-4">
                <h1 className="fs-3 fw-bold mb-2 mb-md-0">Category List</h1>

                <div className="d-flex flex-wrap gap-2">
                  <button
                    className="btn btn-outline-secondary"
                    onClick={() => navigate(`/blog-management/index`)}
                  >
                    <i className="fa fa-list me-1"></i> List Blogs
                  </button>

                  <button
                    className="btn btn-outline-secondary"
                    onClick={() => navigate(`/category-management/index`)}
                  >
                    <i className="fa fa-folder-open me-1"></i> Category
                    Management
                  </button>

                  <button
                    className="btn btn-primary"
                    onClick={() => navigate(`/category-management/category-add`)}
                  >
                    <i className="fa fa-plus-circle me-1"></i> Add New Category
                  </button>
                </div>
              </div>

              {/* Blog Table */}
              <div className="table-responsive">
                <table className="table table-bordered table-hover align-middle">
                  <thead className="table-dark">
                    <tr>
                      <th scope="col">#</th>
                      <th scope="col" style={{ minWidth: "300px" }}>
                        Name
                      </th>
                      <th scope="col">Description</th>
                      <th scope="col">Created</th>
                      <th scope="col">Updated</th>
                      <th scope="col" className="text-center">
                        Actions
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {blogs.map((item, index) => (
                      <tr key={item._id}>
                        <td>{index + 1 + (currentPage - 1) * itemsPerpage}</td>
                        <td>{item.name}</td>
                        <td>{item.description}</td>
                        <td>{moment(item.createdAt).format("DD-MMM-YY")}</td>
                        <td>{moment(item.updatedAt).format("DD-MMM-YY")}</td>
                        <td className="text-center">
                          <div className="btn-group" role="group">
                            
                            
                            <button
                              title="Edit"
                              className="btn btn-sm btn-outline-secondary"
                              onClick={() => handleRedirectEdit(item._id)}
                            >
                              <i className="fa fa-edit"></i>
                            </button>
                            <button
                              title="Delete"
                              className="btn btn-sm btn-outline-danger"
                              onClick={() => handleDeleteConfirmation(item._id)}
                            >
                              <i className="fa fa-trash"></i>
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              {/* Pagination */}
              <div className="d-flex justify-content-between align-items-center mt-4 flex-wrap gap-2">
                <button
                  className="btn btn-outline-primary"
                  onClick={() => handlePageChange(currentPage - 1)}
                  disabled={currentPage === 1}
                >
                  <i className="fa fa-arrow-left me-1"></i> Previous
                </button>

                <div className="d-flex flex-wrap gap-1">
                  {Array.from({ length: totalPages }, (_, index) => (
                    <button
                      key={index}
                      onClick={() => handlePageChange(index + 1)}
                      className={`btn ${
                        currentPage === index + 1
                          ? "btn-primary"
                          : "btn-outline-secondary"
                      }`}
                    >
                      {index + 1}
                    </button>
                  ))}
                </div>

                <button
                  className="btn btn-outline-primary"
                  onClick={() => handlePageChange(currentPage + 1)}
                  disabled={currentPage === totalPages}
                >
                  Next <i className="fa fa-arrow-right ms-1"></i>
                </button>
              </div>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default BlogCategoryShow;
